import { cn } from "@devhop/ui";
import type { ReactNode } from "react";

export type SummaryCardProps = {
  /** ຫົວຂໍ້ຄວາມສັ້ນ (ຕົວຢ່າງ: ຫົວຂໍ້ມູນສະຫຼຸບ) */
  title: string;
  /** ຄ່າຫຼັກທີ່ສະແດງເປັນຕົວເລກ ຫຼື ຂໍ້ຄວາມ */
  value: ReactNode;
  /** ຄຳອະທິບາຍໃຕ້ຄ່າ (ທາງເລືອກ) */
  description?: ReactNode;
  /** ໄອຄອນມຸມຂວາ (ທາງເລືອກ) */
  icon?: ReactNode;
  className?: string;
};

/**
 * ກາດສະຫຼຸບແບບນຳກັບໃຊ້ — ໃຊ້ໃນ dashboard / ລາຍງານຫຍໍ້
 */
export function SummaryCard({
  title,
  value,
  description,
  icon,
  className,
}: SummaryCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-card p-4 shadow-sm",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-1">
          <p className="font-medium text-muted-foreground text-xs uppercase tracking-wide">
            {title}
          </p>
          <p className="font-heading font-semibold text-2xl text-foreground tabular-nums tracking-tight">
            {value}
          </p>
          {description != null && description !== "" ? (
            <p className="text-muted-foreground text-xs leading-snug">
              {description}
            </p>
          ) : null}
        </div>
        {icon ? (
          <div
            className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"
            aria-hidden
          >
            {icon}
          </div>
        ) : null}
      </div>
    </div>
  );
}
